"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const user_types_1 = require("./user.types");
const user_1 = require("services/user-access/user");
const contractor_1 = require("services/master-data/contractor");
const contractor_2 = require("services/master-data/contractor");
const contractor_3 = require("services/master-data/contractor");
const department_1 = require("services/master-data/department");
const role_1 = require("services/user-access/role");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, user_1._getUser)(dataStates);
    if (response.isError) {
        dispatch({
            type: user_types_1.userTypes.SET_ERROR, payload: {
                isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                let a = '';
                item.operator_access.sort((x, y) => ((x === null || x === void 0 ? void 0 : x.checkpoint_name) || '') > ((y === null || y === void 0 ? void 0 : y.checkpoint_name) || '') ? 1 : -1).map(i => {
                    a += a != '' ? ', ' + (i === null || i === void 0 ? void 0 : i.checkpoint_name) : i === null || i === void 0 ? void 0 : i.checkpoint_name;
                });
                return Object.assign(Object.assign({}, item), { operator_access_value: a, created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), status: item.is_active ? 'Active' : 'Inactive' });
            })
        };
        dispatch({ type: user_types_1.userTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => dispatch => {
    const payload = {
        dataStates
    };
    dispatch({ type: user_types_1.userTypes.ON_PAGE_CHANGE, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: user_types_1.userTypes.ON_FILTER_CHANGE, payload });
};
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: user_types_1.userTypes.ON_MUTATION_CLICK, payload });
};
const closeError = () => dispatch => {
    dispatch({
        type: user_types_1.userTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    const { mutationMode } = payload;
    const checkpoints = (_b = (_a = payload.dataItem) === null || _a === void 0 ? void 0 : _a.checkpoint) === null || _b === void 0 ? void 0 : _b.map(i => {
        if (i === null || i === void 0 ? void 0 : i.checkpoint_id) {
            return i === null || i === void 0 ? void 0 : i.checkpoint_id;
        }
        else
            return (i === null || i === void 0 ? void 0 : i.id) || '';
    });
    const response = payload.mutationMode == 'add' ?
        yield (0, user_1._createUser)({
            statusActive: (_c = payload.dataItem) === null || _c === void 0 ? void 0 : _c.is_active.value,
            username: payload.dataItem.username,
            fullName: payload.dataItem.fullname,
            contractorId: payload.dataItem.contractor.id || payload.dataItem.contractor_id,
            departmentId: payload.dataItem.department_obj.id || payload.dataItem.department_id,
            operatorAccessId: checkpoints,
            roleId: payload.dataItem.role.id || '',
            modified_by: payload.dataItem.modified_by,
            password: payload.dataItem.password,
            confirmPassword: payload.dataItem.confirmPassword,
        }) :
        yield (0, user_1._editUser)(Object.assign({ id: payload.dataItem.id, statusActive: (_d = payload.dataItem) === null || _d === void 0 ? void 0 : _d.is_active.value, username: payload.dataItem.username, fullName: payload.dataItem.fullname, contractorId: payload.dataItem.contractor.id || '', departmentId: payload.dataItem.department_obj.id || '', operatorAccessId: checkpoints, roleId: payload.dataItem.role.id || '', modified_by: payload.dataItem.modified_by }, (payload.dataItem.password ? {
            password: payload.dataItem.password,
            confirmPassword: payload.dataItem.confirmPassword,
        } : {})));
    const dataItem = Object.assign(Object.assign({}, payload.dataItem), { id: response.data.id });
    const isSuccess = !response.isError;
    if (isSuccess)
        dispatch({ type: user_types_1.userTypes.ON_SAVE_DATAITEM, payload: Object.assign(Object.assign({}, payload), { dataItem, mutationMode, isSuccess }) });
    else
        dispatch({
            type: user_types_1.userTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage })
        });
});
const onDelete = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, user_1._deleteUser)({ userId: payload.dataItem.id, statusDelete: true });
    if (response.errorMessage === '') {
        const isSuccess = !response.isError;
        if (isSuccess)
            dispatch({ type: user_types_1.userTypes.ON_DELETE, payload: Object.assign(Object.assign({}, payload), { isSuccess }) });
        else
            dispatch({
                type: user_types_1.userTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage })
            });
    }
});
const onReactiveUser = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, user_1._reactiveUser)({ userName: payload.dataItem.username, statusDelete: false });
    if (response.errorMessage === '') {
        const isSuccess = !response.isError;
        if (isSuccess)
            dispatch({ type: user_types_1.userTypes.ON_DELETE, payload: Object.assign(Object.assign({}, payload), { isSuccess }) });
        else
            dispatch({
                type: user_types_1.userTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage })
            });
    }
});
const onReset = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, user_1._resetPassword)({ userId: payload.dataItem.id, statusDelete: false });
    const isSuccess = !response.isError;
    dispatch({ type: user_types_1.userTypes.ON_RESET, payload: Object.assign(Object.assign({}, payload), { isSuccess }) });
});
const getCheckpoint = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const responseCheckpoint = yield (0, user_1._getCheckpoint)();
    const dataCheckpoint = responseCheckpoint.data;
    dispatch({
        type: user_types_1.userTypes.GET_CHECKPOINT, payload: {
            dataCheckpoint
        }
    });
});
const getDetail = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const responseContractor = yield (0, contractor_1._getDropdownMasterContractor)();
    const responseContractorNotKideco = yield (0, contractor_2._getDropdownMasterContractorNotKideco)();
    const responseContractorKideco = yield (0, contractor_3._getDropdownMasterContractorKideco)();
    const responseDepartment = yield (0, department_1._getMasterDepartment)();
    const responseRole = yield (0, role_1._getMasterRole)();
    const dataContractor = responseContractor.data;
    const dataContractorNotKideco = responseContractorNotKideco.data;
    const dataContractorKideco = responseContractorKideco.data;
    const dataDepartment = responseDepartment.data.map(i => {
        return Object.assign(Object.assign({}, i), { department_name: i.department });
    });
    const dataRole = responseRole.data;
    dispatch({
        type: user_types_1.userTypes.GET_DETAIL, payload: {
            dataContractorNotKideco,
            dataContractorKideco,
            dataContractor,
            dataDepartment,
            dataRole,
        }
    });
});
exports.default = {
    onReset,
    onDelete,
    getDetail,
    closeError,
    getDataGrid,
    getCheckpoint,
    onSaveDataItem,
    onFilterChange,
    onClickMutation,
    onDataStateChange,
    onReactiveUser
};
